import { render, staticRenderFns } from "./ApproveStock.vue?vue&type=template&id=a6ccd644&"
import script from "./ApproveStock.vue?vue&type=script&lang=js&"
export * from "./ApproveStock.vue?vue&type=script&lang=js&"
import style0 from "./ApproveStock.vue?vue&type=style&index=0&id=a6ccd644&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports